var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationSeating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6275 6.9975C15.4575 8.8275 15.4575 11.7956 13.6275 13.6275C11.7975 15.4594 8.82937 15.4575 6.9975 13.6275C5.1675 11.7975 5.1675 8.82937 6.9975 6.9975C8.82937 5.1675 11.7956 5.1675 13.6275 6.9975Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0022 31.3722C39.8322 33.2022 39.8322 36.1704 38.0022 38.0022C36.1722 39.8341 33.2041 39.8322 31.3722 38.0022C29.5404 36.1722 29.5422 33.2041 31.3722 31.3722C33.2022 29.5404 36.1704 29.5422 38.0022 31.3722Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6275 31.3722C15.4575 33.2022 15.4575 36.1704 13.6275 38.0022C11.7975 39.8341 8.82937 39.8322 6.9975 38.0022C5.1675 36.1722 5.1675 33.2041 6.9975 31.3722C8.8275 29.5404 11.7956 29.5422 13.6275 31.3722Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0022 6.9975C39.8322 8.8275 39.8322 11.7956 38.0022 13.6275C36.1722 15.4594 33.2041 15.4575 31.3722 13.6275C29.5404 11.7975 29.5422 8.82937 31.3722 6.9975C33.2041 5.1675 36.1704 5.1675 38.0022 6.9975Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 35.4749C21.2381 35.563 21.8625 35.6249 22.5 35.6249C23.1375 35.6249 23.7619 35.563 24.375 35.4749",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 9.525C21.2381 9.43687 21.8625 9.375 22.5 9.375C23.1375 9.375 23.7619 9.43687 24.375 9.525",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4751 24.375C35.5632 23.7619 35.6251 23.1375 35.6251 22.5C35.6251 21.8625 35.5632 21.2381 35.4751 20.625",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.525 24.375C9.43687 23.7619 9.375 23.1375 9.375 22.5C9.375 21.8625 9.43687 21.2381 9.525 20.625",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationSeating);
export default __webpack_public_path__ + "static/media/navigation-seating.72c173b4.svg";
export { ForwardRef as ReactComponent };